import { defaultHandleTournamentClick } from '@sportal365/smp-widget-utils';
import { SMPFlex, SMPImage, SMPText } from '@velinsi/smp-widgets-ui';
import { FC } from 'react';
import { ISubscriberInfoFn } from '../../main';

interface ICompetitionProps {
  id: string;
  logo?: string;
  subText: string | null;
  name: string;
  target?: string;
  link?: string;
  handleClick: ISubscriberInfoFn;
}

export const Competition: FC<ICompetitionProps> = ({ id, logo, name, subText, target, link, handleClick }) => {
  const handleCompetitionClick = () => defaultHandleTournamentClick(handleClick, id ?? '', name);

  return (
    <a href={link} target={target} style={{ display: 'inline-flex', textDecoration: 'none' }} onClick={handleCompetitionClick}>
      <SMPFlex variant='column' align='center' justify={'center'} css={{ px: '$2', borderRight: '1px solid $borderMultiSportColor' }}>
        {logo && <SMPImage width={'16px'} src={logo} />}
        <SMPText css={{ fontSize: '$2_5', fontWeight: 'bold', lineHeight: '20px', color: '$multiSportTextColor', whiteSpace: 'nowrap' }}>
          {name}
        </SMPText>
        {subText && (
          <SMPText
            css={{ fontSize: '$2', lineHeight: '16px', color: '$multiSportCommonColor', whiteSpace: 'nowrap', textTransform: 'capitalize' }}
          >
            {subText}
          </SMPText>
        )}
      </SMPFlex>
    </a>
  );
};
